 <template>
  <div class="crm-panel">
    <slot name="tooltip" />
    <span class="panel-title" v-if="title">{{title}}</span>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.crm-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  padding: 20px 20px 0 20px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: @box-shadow;
  background-color: @bg--white;
  .buttons {
    display: inline-block;
  }
}

</style>
